import React, { type FC, useMemo } from 'react';
import type { ProductOptionsProps } from './product-options.types';
import { Chip } from '../../atoms/chip';
import { Text } from '../../atoms/text';
import { cn } from '../../utils/cn';
import { CartItemTypeEnum } from '../../organisms/cart-item-v2/cart-item-v2.enum';

import styles from './product-options.module.css';

export const ProductOptions: FC<ProductOptionsProps> = ({ item, containerStyle }) => {
    const configurableItem = item; // --> as ConfigurableCartItem;
    // Memoize the options string to avoid recalculating on every render
    const optionsText = useMemo(() => {
        return (
            configurableItem.configurable_options
                // eslint-disable-next-line
                ?.map((option: any) => `${option?.option_label}: ${option?.value_label}`)
                .join(', ')
        );
    }, [configurableItem.configurable_options]);

    if (item.__typename !== CartItemTypeEnum.CONFIGURABLE && item.__typename !== CartItemTypeEnum.CONFIGURABLE_LOCAL) {
        return null;
    }

    // Early return if no options text
    if (!optionsText) {
        return null;
    }

    return (
        <div className={cn(styles.container, containerStyle)}>
            <Chip className={styles.item}>
                <Text className={styles.text}>{optionsText}</Text>
            </Chip>
        </div>
    );
};

ProductOptions.displayName = 'ProductOptions';
